import React from 'react';
import styled from 'styled-components';
import { CloudUpload } from '@mui/icons-material';

const UploaderContainer = styled.div<{ disabled?: boolean }>`
  position: relative;
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  background-color: ${props => props.disabled ? '#f0f0f0' : '#f5f5f5'};
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  opacity: ${props => props.disabled ? 0.6 : 1};
  transition: all 0.3s ease;

  &:hover {
    background-color: ${props => props.disabled ? '#f0f0f0' : '#e8e8e8'};
  }
`;

const HiddenInput = styled.input<{ disabled?: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
`;

const UploadIcon = styled(CloudUpload)`
  font-size: 48px;
  color: #666;
  margin-bottom: 16px;
`;

const Label = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: #333;
`;

interface FileUploaderProps {
  accept?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  subLabel?: string;
  icon?: React.ReactNode;
  disabled?: boolean;
}

const FileUploader: React.FC<FileUploaderProps> = ({
  accept = '*',
  onChange,
  label = 'ファイルを選択',
  subLabel = 'またはドラッグ&ドロップ',
  icon,
  disabled = false
}) => {
  return (
    <UploaderContainer disabled={disabled}>
      <HiddenInput
        type="file"
        accept={accept}
        onChange={onChange}
        disabled={disabled}
      />
      {icon || <UploadIcon />}
      <Label>
        {label}
        {subLabel && (
          <>
            <br />
            {subLabel}
          </>
        )}
      </Label>
    </UploaderContainer>
  );
};

export default FileUploader;